<template>
    <HeaderContent title="Vendor"/>
    <ActionContent ctaText="Vendor" @action="modal = !modal "/>
    <AdminStatistics title="Vendor Statistics" :data="statistics" />
    <VendorForm :modal="modal" @updateModal="modal = !modal"></VendorForm>
    <AdminDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions">
    </AdminDataTable>
    
</template>

<script >
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import VendorForm from './VendorForm.vue';
import AdminDataTable from '@/components/DataTable.vue';
import AdminStatistics from '@/components/StatisticData.vue';
import iconSeller from '../../../public/icons/seller.svg'
import vendorDummy from '@/dummy-data/vendor.js'
import { ref,} from 'vue';


// Statistics Attr
export default {
    name : 'VendorIndex',
    components : {
        HeaderContent,
        ActionContent,
        VendorForm,
        AdminDataTable,
        AdminStatistics
    },
    setup(){
        const modal = ref(false)
        const data = vendorDummy
        const statistics = ref([
            {
                label: 'Total',
                key: 'Vendor',
                value: 5,
                color: 'info',
                icon: iconSeller,
            },
        ])

        // Table Attr
        const headers = ref([
            {key : 'id',label: 'ID',sortable: true,},
            {key : 'vendor_name', label : 'Vendor Name',sortable: true, },
            {key : 'pic_name', label : 'PIC Name',sortable: true, },
            {key : 'contact', label : 'Contact',sortable: true, },
            {key : 'email', label : 'Email',sortable: true,},
            {key : 'address', label : 'Address',sortable: true,},
            {key : 'status', label : 'Status',sortable: true,},
            {key: 'action', label: 'Action',}
        ])
        const customActions = ref([
            {
                label: ((item)=>item.status == 'Active' ? 'Deactivate' : 'Activate'),
                icon: ((item)=>item.status == 'Active' ? 'fas fa-user-slash' : 'fas fa-user-check'),
                variant: ((item)=>item.status == 'Active' ? 'secondary' : 'primary'),
                action: (item) => {

                console.log('Extra charge action clicked for:', item);
                // Implement your extra charge logic here
                }
            ,
            },
        
            {
                label: 'Edit',
                variant: 'success',
                icon: 'fas fa-edit',
                action: (item) => {
                console.log('Edit action clicked for:', item);
                // Implement your edit logic here
                }
            },
            {
                label: 'Delete',
                variant: 'danger',
                icon: 'fas fa-trash',
                action: (item) => {
                console.log('Delete action clicked for:', item);
                // Implement your delete logic here
                }
            },
            
        ]);

        return { modal, statistics, headers, customActions, data }
    }
}
</script>



